{
  "APP_NAME": "verein.cloud®",
  "Verein": "Verein",
  "Vereins": "Vereins",
  "ABOUT_VEREIN": "Con verein.cloud® ofrecemos un valor añadido y fuentes de ingresos para asociaciones que van más allá de los ingresos por membresía. Una plataforma de donaciones crea acceso automatizado a la financiación de planes y proyectos. Con el acceso perfilado a los miembros del club, los clubes pueden integrar a sus patrocinadores de manera más sostenible. Los miembros y las asociaciones se benefician de funciones de fidelización, cupones o reembolsos y otros valores añadidos y servicios.",
  "PASSWORD_RESET_SUCCESS_MESSAGE": "Se ha enviado un enlace para restablecer la contraseña. Verifique su bandeja de entrada para un correo electrónico de support@verein.cloud.",
  "New Version is Available.": "Hay una nueva versión disponible.",
  "Please Click to Update": "Por favor, haga clic para actualizar",
  "Forgot Password": "Olvidó su contraseña",
  "Back to login": "Volver al inicio de sesión",
  "Submit": "Enviar",
  "Welcome": "Bienvenido",
  "Login Successful": "Inicio de sesión exitoso",
  "Your account has been deleted. Please contact support. Logging out...": "Tu cuenta ha sido eliminada. Por favor, ponte en contacto con soporte. Cerrando sesión...",
  "Your account has been deleted. Please contact support.": "Tu cuenta ha sido eliminada. Por favor, ponte en contacto con soporte.",
  "Admin": "Administrador",
  "Member": "Miembro",
  "Guest": "Invitado",
  "Secretary": "Secretario",
  "Functionary": "Funcionario",
  "Editor": "Editor",
  "User": "Usuario",
  "Member Light": "Miembro Light",
  "Member Light Admin": "Administrador de Miembro Light",
  "About": "Acerca de",
  "Chairman": "Presidente",
  "Hello world !": "¡Hola Mundo!",
  "Not Found": "No encontrado",
  "Unauthorized Access": "Acceso no autorizado",
  "Home": "Inicio",
  "Logged in as": "Conectado como",
  "Login": "Iniciar sesión",
  "Logout": "Salir",
  "Password": "Contraseña",
  "Password is required": "Se requiere contraseña",
  "Username": "Nombre de usuario",
  "Username is required": "Se requiere nombre de usuario",
  "Username or password incorrect.": "Usuario o contraseña incorrectos.",
  "Remember me": "Recuérdame",
  "Version": "Versión",
  "Details": "Detalles",
  "Yes": "Sí",
  "No": "No",
  "Old Password": "Contraseña Antigua",
  "New Password": "Nueva Contraseña",
  "Confirm Password": "confirmar contraseña",
  "Confirmation": "Confirmación",
  "Delete Confirmation": "Confirmación de Eliminación",
  "Move to Trash Confirmation": "Mover a la Papelera de Reciclaje",
  "Leave Confirmation": "Confirmación de Salida",
  "Join Confirmation": "Confirmación de Unirse",
  "Approve Join Confirmation": "Confirmación de Aprobar Unirse",
  "Accept Confirmation": "Confirmación de aceptación",
  "Deny Confirmation": "Confirmación de denegación",
  "Approve Confirmation": "Confirmación de aprobación",
  "Reject Confirmation": "Confirmación de rechazo",
  "Shifts Delete Confirmation": "Confirmación de eliminación de turnos",
  "Accept Successful": "Aceptación exitosa",
  "Deny Successful": "Denegación exitosa",
  "Unapprove Successful": "Desaprobación exitosa",
  "Approve Successful": "Aprobación exitosa",
  "Created Successfully": "Creado exitosamente",
  "Update Successful": "Actualización exitosa",
  "Delete Successful": "Eliminación exitosa",
  "Leave Successful": "Salida exitosa",
  "Join Successful": "Unión exitosa",
  "Approved Successfully": "Aprobado exitosamente",
  "Rejected Successfully": "Rechazado exitosamente",
  "Message starred successfully": "Mensaje marcado con éxito",
  "Message moved to inbox successfully": "Mensaje movido a la bandeja de entrada con éxito",
  "Message saved as draft successfully": "Mensaje guardado como borrador con éxito",
  "Message moved to trash successfully": "Mensaje movido a la papelera con éxito",
  "Error": "Error",
  "Something went wrong": "¡Algo salió mal!",
  "Are you sure you want to continue": "Estás seguro de que quieres continuar",
  "Are you sure you want to delete": "Estás seguro de que quieres eliminar",
  "Are you sure you want to leave": "Estás seguro de que quieres salir",
  "Are you sure you want to join": "Estás seguro de que quieres unirte",
  "Are you sure you want to join {eventName} event on {eventDate}?": "¿Estás seguro de que quieres unirte al evento <b>'{{eventName}}'</b> el <b>{{eventDate}}</b>?",
  "Are you sure you want to join {eventName} for all upcoming events?": "¿Estás seguro de que quieres unirte a <b>'{{eventName}}'</b> para todos los próximos eventos?",
  "Are you sure you want to join {eventName} event on selected dates?": "¿Estás seguro de que quieres unirte al evento <b>'{{eventName}}'</b> en las fechas seleccionadas?",
  "Your current Request is waiting for the Approval": "Tu solicitud actual está esperando la aprobación.",
  "Current Request is waiting for the Approval by Admin": "La solicitud actual está esperando la aprobación del administrador",
  "Current request has been denied": "La solicitud actual ha sido denegada",
  "Your current request is Rejected": "Tu solicitud actual ha sido rechazada",
  "Your current request is Approved": "Tu solicitud actual ha sido aprobada",
  "Deny Reason": "Motivo de Negación",
  "Your current Request is waiting for the Approval by Admin": "Su solicitud actual está esperando la aprobación del administrador.",
  "Your current request is Denied by Admin": "Su solicitud actual ha sido denegada por el administrador.",
  "Your update request is waiting for the approval by Admin": "Su solicitud de actualización está esperando la aprobación del administrador.",
  "Update request is waiting for the approval": "La solicitud de actualización está esperando la aprobación.",
  "You have unsaved changes. Are you sure you want to leave": "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir",
  "confirmationDivider": "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
  "Are you sure you want to accept this": "¿Estás seguro de que quieres aceptar esto ",
  "Are you sure you want to deny this": "¿Estás seguro de que quieres negar esto ",
  "Are you sure you want to approve this": "¿Está seguro de que desea aprobar esto ",
  "Are you sure you want to reject this": "¿Está seguro de que desea rechazar esto ",
  "Are you sure you want to unapprove this": "¿Estás seguro de que quieres desaprobar esto ",
  "Are you sure you want to accept this Course": "¿Está seguro de que desea aceptar este curso",
  "Are you sure you want to deny this Course": "¿Está seguro de que desea rechazar este curso",
  "Are you sure you want to approve this Course": "¿Está seguro de que desea aprobar este curso",
  "Are you sure you want to reject this Course": "¿Está seguro de que desea rechazar este curso",
  "Are you sure you want to unapprove this Course": "¿Está seguro de que desea desaprobar este curso",
  "Are you sure you want to accept this Event": "¿Está seguro de que desea aceptar este evento",
  "Are you sure you want to deny this Event": "¿Está seguro de que desea rechazar este evento",
  "Are you sure you want to approve this Event": "¿Está seguro de que desea aprobar este evento",
  "Are you sure you want to reject this Event": "¿Está seguro de que desea rechazar este evento",
  "Are you sure you want to unapprove this Event": "¿Está seguro de que desea desaprobar este evento",
  "Are you sure you want to accept this News": "¿Está seguro de que desea aceptar estas noticias",
  "Are you sure you want to deny this News": "¿Está seguro de que desea rechazar estas noticias",
  "Are you sure you want to approve this News": "¿Está seguro de que desea aprobar estas noticias",
  "Are you sure you want to reject this News": "¿Está seguro de que desea rechazar estas noticias",
  "Are you sure you want to unapprove this News": "¿Está seguro de que desea desaprobar estas noticias",
  "Are you sure you want to accept this Task": "¿Está seguro de que desea aceptar esta tarea",
  "Are you sure you want to deny this Task": "¿Está seguro de que desea rechazar esta tarea",
  "Are you sure you want to approve this Task": "¿Está seguro de que desea aprobar esta tarea",
  "Are you sure you want to reject this Task": "¿Está seguro de que desea rechazar esta tarea",
  "Are you sure you want to unapprove this Task": "¿Está seguro de que desea desaprobar esta tarea",
  "Are you sure you want to accept this Group": "¿Está seguro de que desea aceptar este grupo",
  "Are you sure you want to deny this Group": "¿Está seguro de que desea rechazar este grupo",
  "Are you sure you want to approve this Group": "¿Está seguro de que desea aprobar este grupo",
  "Are you sure you want to reject this Group": "¿Está seguro de que desea rechazar este grupo",
  "Are you sure you want to unapprove this Group": "¿Está seguro de que desea desaprobar este grupo",
  "Are you sure you want to accept this FAQ": "¿Está seguro de que desea aceptar estas preguntas frecuentes",
  "Are you sure you want to deny this FAQ": "¿Está seguro de que desea rechazar estas preguntas frecuentes",
  "Are you sure you want to approve this FAQ": "¿Está seguro de que desea aprobar estas preguntas frecuentes",
  "Are you sure you want to reject this FAQ": "¿Está seguro de que desea rechazar estas preguntas frecuentes",
  "Are you sure you want to unapprove this FAQ": "¿Está seguro de que desea desaprobar estas preguntas frecuentes",
  "Are you sure you want to accept this Instructor": "¿Está seguro de que desea aceptar este instructor",
  "Are you sure you want to deny this Instructor": "¿Está seguro de que desea rechazar este instructor",
  "Are you sure you want to approve this Instructor": "¿Está seguro de que desea aprobar este instructor",
  "Are you sure you want to reject this Instructor": "¿Está seguro de que desea rechazar este instructor",
  "Are you sure you want to unapprove this Instructor": "¿Está seguro de que desea desaprobar este instructor",
  "Are you sure you want to accept this Room": "¿Está seguro de que desea aceptar esta sala",
  "Are you sure you want to deny this Room": "¿Está seguro de que desea rechazar esta sala",
  "Are you sure you want to approve this Room": "¿Está seguro de que desea aprobar esta sala",
  "Are you sure you want to reject this Room": "¿Está seguro de que desea rechazar esta sala",
  "Are you sure you want to unapprove this Room": "¿Está seguro de que desea desaprobar esta sala",
  "Are you sure you want to accept this Survey": "¿Está seguro de que desea aceptar esta encuesta",
  "Are you sure you want to deny this Survey": "¿Está seguro de que desea rechazar esta encuesta",
  "Are you sure you want to approve this Survey": "¿Está seguro de que desea aprobar esta encuesta",
  "Are you sure you want to reject this Survey": "¿Está seguro de que desea rechazar esta encuesta",
  "Are you sure you want to unapprove this Survey": "¿Está seguro de que desea desaprobar esta encuesta",
  "Are you sure you want to delete all shifts for": "¿Estás seguro de que quieres eliminar todos los turnos para",
  "Are you sure you want to move this to trash": "¿Estás seguro de que quieres mover esto a la papelera",
  "Are you sure you want to permanently delete this": "¿Estás seguro de que quieres eliminar esto permanentemente",
  "Are you sure you want to approve this join request": "¿Estás seguro de que quieres aprobar esta solicitud de unión",
  "Are you sure you want to delete this image": "¿Estás seguro de que quieres eliminar esta imagen",
  "Are you sure you want to delete this document": "¿Estás seguro de que quieres eliminar este documento",
  "Are you sure you want to complete this task": "¿Estás seguro de que quieres completar esta tarea",
  "Club Surveys": "Encuestas de club",
  "Active Polls": "Encuestas activas",
  "My Polls": "Mis encuestas",
  "Completed Polls": "Encuestas completadas",
  "Completed Surveys": "Encuestas completadas",
  "Opinion Poll": "Encuesta de opinión",
  "owner": "Propietario",
  "Active on": "Activo en",
  "Active from": "Activo desde",
  "Expired on": "Expirado en",
  "remaining time": "Tiempo restante",
  "status": "Estado",
  "Add Survey": "Agregar Encuesta",
  "View Survey": "Ver Encuesta",
  "Delete Survey": "eliminar encuesta",
  "Active Survey": "Encuesta activa",
  "Close Survey": "Cerrar encuesta",
  "Survey Activated Successfully": "Encuesta activada correctamente",
  "Survey Closed Successfully": "Encuesta cerrada correctamente",
  "Survey Close Confirmation": "Confirmación de cierre de encuesta",
  "Survey Active Confirmation": "Confirmación de activación de encuesta",
  "Are you sure you want to active": "Está seguro de que desea activar",
  "Are you sure you want to close": "Está seguro de que desea cerrar",
  "Leave": "Salir",
  "Edit": "Editar",
  "Delete": "Eliminar",
  "Remove": "Eliminar",
  "Add": "Agregar",
  "Create": "Crear",
  "Save": "Guardar",
  "Update": "Actualizar",
  "update": "Actualizar",
  "Cancel": "Cancelar",
  "Back": "Atrás",
  "accept": "Aceptar",
  "Accept": "Aceptar",
  "Decline": "Declinar",
  "deny": "Negar",
  "Deny": "Negar",
  "view": "Ver",
  "View": "Ver",
  "view survey": "Ver Encuesta",
  "view task": "Ver Tarea",
  "View Task": "Ver Tarea",
  "Drag and drop image here, or click to add image": "Arrastra y suelta la imagen aquí o haz clic para añadir una imagen",
  "Drag and drop image here, or click to change image": "Arrastra y suelta la imagen aquí o haz clic para cambiar la imagen",
  "Drag and drop file here, or click to add file": "Arrastra y suelta el archivo aquí o haz clic para añadir un archivo",
  "Drag and drop file here, or click to change file": "Arrastra y suelta el archivo aquí o haz clic para cambiar el archivo",
  "Add Image": "Agregar imagen",
  "Add File": "Agregar archivo",
  "Change Image": "Cambiar imagen",
  "View more": "Ver más",
  "Notifications": "Notificaciones",
  "See more Notifications": "Ver más notificaciones",
  "Title": "Título",
  "Start Date": "Fecha de inicio",
  "End Date": "Fecha de finalización",
  "New Survey": "Nueva Encuesta",
  "Survey Edit": "Editar Encuesta",
  "Survey Details": "Detalles de la Encuesta",
  "Survey": "Encuesta",
  "Question": "Pregunta",
  "Single selection": "Selección única",
  "Multiple selection": "Selección múltiple",
  "Add Choice": "Agregar opción",
  "Enter your question": "Introduce tu pregunta",
  "Publish": "Publicar",
  "Add Question": "Agregar Pregunta",
  "Enter your survey name": "Introduce el nombre de tu encuesta",
  "Assigned tasks": "Tareas asignadas",
  "About event": "Acerca del evento",
  "Event details": "Detalles del evento",
  "Clear All": "Borrar todo",
  "Select Date": "Seleccionar fecha",
  "Delete Banner": "Eliminar banner",
  "Banner": "Banner",
  "Banners": "Banners",
  "Email Type": "Tipo de correo electrónico",
  "Subject": "Asunto",
  "To": "A",
  "Cc": "Cc",
  "Recipients": "Destinatarios",
  "Edit Draft Message": "Editar Borrador",
  "Header Content": "Contenido del encabezado",
  "Template Body": "Cuerpo de la plantilla",
  "Footer Content": "Contenido del pie de página",
  "Url": "URL",
  "Action": "Acción",
  "Thumbnail": "Miniatura",
  "From": "De",
  "Template Type": "Tipo de plantilla",
  "Header Subject": "Asunto del encabezado",
  "Email Template": "Plantilla de correo electrónico",
  "Create Email Template": "Crear plantilla de correo electrónico",
  "Content": "Contenido",
  "instructor": "Instructor",
  "survey": "Encuesta",
  "course": "Curso",
  "updatedcourse": "Curso Actualizado",
  "Select Option": "Seleccionar opción",
  "Select Options": "Seleccionar opciones",
  "Tag": "Etiqueta",
  "Tags": "Etiquetas",
  "Tag Name": "Nombre de la etiqueta",
  "Create Tag": "Crear etiqueta",
  "Instructor Tag Name": "Nombre de la etiqueta del instructor",
  "Room Tag Name": "Nombre de la etiqueta de la sala",
  "Courses": "Cursos",
  "Instructor": "Instructor",
  "Room": "Habitación",
  "Rooms": "Habitaciones",
  "New Tag": "Nueva etiqueta",
  "Task": "Tarea",
  "task": "Tarea",
  "Event": "Evento",
  "Events": "Eventos",
  "Event Name": "Nombre del evento",
  "Event Type": "Tipo de evento",
  "FAQs": "Preguntas Frecuentes",
  "Surveys": "Encuestas",
  "News": "Noticias",
  "news": "Noticias",
  "news posts": "Publicaciones de Noticias",
  "news post": "Publicación de Noticias",
  "create news post": "Crear Publicación de Noticias",
  "edit news post": "Editar Publicación de Noticias",
  "news post details": "Detalles de la Publicación de Noticias",
  "discover": "Descubrir",
  "create news": "Crear Noticias",
  "news from the groups": "Noticias de los grupos",
  "No Available Content": "No hay contenido disponible",
  "re you sure you want to delete this Tag?": "¿Estás seguro de que quieres eliminar esta etiqueta?",
  "Update Tag": "Actualizar etiqueta",
  "Add task": "Agregar tarea",
  "Tasks": "Tareas",
  "Task details": "Detalles de la tarea",
  "Create task": "Crear tarea",
  "Edit task": "Editar tarea",
  "All tasks": "Todas las tareas",
  "My tasks": "Mis tareas",
  "Completed tasks": "Tareas completadas",
  "Open tasks": "Tareas abiertas",
  "Group tasks": "Tareas de grupo",
  "New task": "Nueva tarea",
  "Subtasks": "Subtareas",
  "Add Sub-task": "Agregar subtarea",
  "Select date": "Seleccionar fecha",
  "Select Time": "Seleccionar hora",
  "ToDo": "Por hacer",
  "In-Progress": "En progreso",
  "InProgress": "En progreso",
  "Completed": "Completado",
  "Comments": "Comentarios",
  "Assigned": "Asignado",
  "Assign to": "Asignar a",
  "Add a Card": "Agregar una tarjeta",
  "Add Card": "Agregar tarjeta",
  "Add element": "Agregar elemento",
  "Enter a title for this card": "Introduce un título para esta tarjeta",
  "Tasks to be completed": "Tareas por completar",
  "No Available Tasks": "No hay tareas disponibles",
  "Group": "Grupo",
  "Individual": "Individual",
  "Task type": "Tipo de tarea",
  "Add Tag": "Agregar etiqueta",
  "Enter Title": "Introducir título",
  "Enter Description": "Introducir descripción",
  "Select": "Seleccionar",
  "News Posts": "Publicaciones de noticias",
  "Posts": "Publicaciones",
  "Message Chats": "Chats de mensajes",
  "Message": "Mensaje",
  "Chats": "Chats",
  "Tasks Events": "Eventos de tareas",
  "news from the club": "noticias del club",
  "News from the group": "Noticias del grupo",
  "News from the Company": "Noticias de la Empresa",
  "Current club dates": "Fechas actuales del club",
  "Current company dates": "Fechas actuales de la empresa",
  "Participant": "Participante",
  "Read more": "Leer más",
  "Clock": "Reloj",
  "Popular": "Popular",
  "Latest": "Último",
  "Available Tasks": "Tareas disponibles",
  "Available": "Disponible",
  "New": "Nuevo",
  "No News": "Sin noticias",
  "Menu": "Menú",
  "Answer Options": "Opciones de respuesta",
  "Enter answer choice": "Introduce la opción de respuesta",
  "Answer": "Respuesta",
  "Survey Type": "Tipo de encuesta",
  "Type": "Tipo",
  "View Options": "Ver opciones",
  "Notification": "Notificación",
  "Anonymous Voting": "Votación anónima",
  "Allow Correcting the Cast Vote": "Permitir corregir el voto emitido",
  "Multiple Choice": "Selección múltiple",
  "Single Choice": "Selección única",
  "Web Notification": "Notificación web",
  "Email Notification": "Notificación por correo electrónico",
  "Always": "Siempre",
  "After Voting": "Después de votar",
  "Never": "Nunca",
  "All Club": "Todo el club",
  "All Important Dates": "Todas las Fechas Importantes",
  "Jubilees": "Jubileos",
  "Birthdays": "Cumpleaños",
  "Anniversary": "Aniversario",
  "Birthday": "Cumpleaños",
  "days ago": "días atrás",
  "days left": "días restantes",
  "years": "años",
  "years in club": "años en el club",
  "Today": "Hoy",
  "Today is": "Hoy es",
  "No upcoming birthdays or anniversaries": "No hay próximos cumpleaños o aniversarios",
  "Say Congrats": "Decir Felicidades",
  "Reply": "Responder",
  "Reply All": "Responder a todos",
  "Forward": "Reenviar",
  "No Messages": "Sin mensajes",
  "All Events": "Todos los Eventos",
  "Club Event": "Evento del Club",
  "Group Event": "Eventos del Grupo",
  "Functionaries Event": "Evento de Funcionarios",
  "Course": "Curso",
  "Seminar": "Seminario",
  "Items Per Page": "Elementos por página",
  "Description": "Descripción",
  "Enter to search": "Presiona Enter para buscar",
  "New Chat": "Nuevo Chat",
  "New Email": "Nuevo Correo Electrónico",
  "Email": "Correo Electrónico",
  "E-Mail": "Correo Electrónico",
  "Select an email to start communication": "Selecciona un correo electrónico para iniciar la comunicación",
  "Select a chat to start messaging": "Selecciona un chat para empezar a enviar mensajes",
  "Looks like you haven’t initiated a conversation with any of your team members": "Parece que no has iniciado una conversación con ninguno de los miembros de tu equipo",
  "Enter your survey description": "Introduce la descripción de tu encuesta",
  "Manage members and set their access level in your workspace": "Administra a los miembros y establece su nivel de acceso en tu espacio de trabajo",
  "New Message": "Nuevo Mensaje",
  "Message Type": "Tipo de mensaje",
  "Add a subject...": "Agregar un asunto...",
  "Select A Message": "Seleccionar un mensaje",
  "Choose File": "Elegir archivo",
  "Change File": "Cambiar archivo",
  "Type a message...": "Escribe un mensaje...",
  "Draft": "Borrador",
  "Drafts": "Borradores",
  "Send": "Enviar",
  "Bin": "Papelera",
  "All Messages": "Todos los mensajes",
  "Posted": "Publicado",
  "Marked": "Marcado",
  "Inbox": "Bandeja de entrada",
  "Trash": "Papelera",
  "Starred": "Destacado",
  "Sent": "Enviado",
  "All Mails": "Todos los Correos",
  "Personal": "Personal",
  "Sorting": "Ordenación",
  "Active Member": "Miembro Activo",
  "Membership number": "Número de membresía",
  "In the team since": "En el equipo desde",
  "In the club since": "En el club desde",
  "Category": "Categoría",
  "Position": "Posición",
  "Category Name": "Nombre de la categoría",
  "Select Language": "Seleccionar idioma",
  "Select Theme": "Seleccionar tema",
  "No record found": "No se encontraron registros",
  "No items available": "No hay elementos disponibles",
  "No tags available": "No hay etiquetas disponibles",
  "Internal": "Interno",
  "External": "Externo",
  "Booked Out": "Reservado",
  "Internal Instructor": "Instructor Interno",
  "External Instructor": "Instructor Externo",
  "Instructor Type": "Tipo de instructor",
  "Faq Category": "Categoría de FAQ",
  "Faq Category Name": "Nombre de la categoría de FAQ",
  "Sort and Filter": "Ordenar y Filtrar",
  "Clear": "Borrar",
  "Select Tags": "Seleccionar etiquetas",
  "Name of the Event": "Nombre del evento",
  "Venue": "Lugar",
  "Add Venue": "Agregar lugar",
  "No venue available": "No hay lugar disponible",
  "Event Venues": "Lugares de eventos",
  "Create Event Venue": "Crear lugar de evento",
  "Event Venue Name": "Nombre del lugar del evento",
  "Event Types": "Tipos de evento",
  "Visibility of Event": "Visibilidad del evento",
  "Show Guests": "Mostrar invitados",
  "Chargeable": "Cobrable",
  "Additional Features": "Características adicionales",
  "Event Price": "Precio del evento",
  "Assign a task to an event": "Asignar una tarea a un evento",
  "Task Description": "Descripción de la tarea",
  "Task Types": "Tipos de tarea",
  "Week Days": "Días de la semana",
  "Recurrence": "Recurrencia",
  "Start Time": "Hora de inicio",
  "End Time": "Hora de finalización",
  "Event Date": "Fecha del evento",
  "Event Time": "Hora del evento",
  "Room No (optional)": "Número de habitación (opcional)",
  "Repeat Event": "Repetir evento",
  "Image": "Imagen",
  "Enter Price": "Introducir precio",
  "Time From": "Hora Desde",
  "Time To": "Hora Hasta",
  "Every": "Cada",
  "Days": "Días",
  "Weeks": "Semanas",
  "Months": "Meses",
  "Years": "Años",
  "Day": "Día",
  "Repeat Daily": "Repetir Diariamente",
  "Repeat Weekly": "Repetir Semanalmente",
  "Repeat Monthly": "Repetir Mensualmente",
  "Repeat Yearly": "Repetir Anualmente",
  "Public": "Público",
  "Private": "Privado",
  "Club": "Club",
  "Clubs": "Clubes",
  "Company": "Empresa",
  "Does Not Repeat": "No se repite",
  "Every Day": "Cada día",
  "Every Week": "Cada semana",
  "Every Month": "Cada mes",
  "Every Year": "Cada año",
  "Custom": "Personalizado",
  "Club  Event": "Evento del Club",
  "Participants": "Participantes",
  "Select Participants": "Seleccionar participantes",
  "Private Group": "Grupo privado",
  "Course Information": "Información del curso",
  "Place": "Lugar",
  "Date": "Fecha",
  "Time": "Hora",
  "Instructor Name": "Nombre del instructor",
  "Available Times": "Horarios disponibles",
  "Qualification": "Calificación",
  "More Courses": "Más cursos",
  "Theme": "Tema",
  "Room Information": "Información de la sala",
  "Task Details": "Detalles de la tarea",
  "Assignment": "Asignación",
  "Due Date": "Fecha de vencimiento",
  "Room Details": "Detalles de la sala",
  "Address": "Dirección",
  "People": "Personas",
  "Pending": "Pendiente",
  "Approved": "Aprobado",
  "Room Info": "Información de la sala",
  "To be submitted at the of course": "Para ser presentado al final del curso",
  "Add Course": "Agregar Curso",
  "Add Tags": "Agregar etiquetas",
  "Course Date": "Fecha del curso",
  "Allowed Persons": "Personas permitidas",
  "Add a Title": "Agregar un título",
  "Headline": "Titular",
  "Types": "Tipos",
  "Enter headline": "Introduce el titular",
  "Enter content": "Introduce el contenido",
  "News Highlight": "Noticias destacadas",
  "Club News": "Noticias del club",
  "Company News": "Noticias de la empresa",
  "New from the club": "Nuevo del club",
  "New Posts": "Nuevas publicaciones",
  "Task Events": "Eventos de tareas",
  "Groups": "Grupos",
  "Group Details": "Detalles del grupo",
  "Delete Group": "Eliminar grupo",
  "Leave Group": "Salir del grupo",
  "Join Group": "Unirse al grupo",
  "Join": "Unirse",
  "Group Name": "Nombre del grupo",
  "Course Name": "Nombre del Curso",
  "Visibility": "Visibilidad",
  "No file chosen": "Ningún archivo seleccionado",
  "Assign a task to course": "Asignar una tarea al curso",
  "Please fill all required fields": "Por favor, complete todos los campos obligatorios",
  "Room Availability": "Disponibilidad de la Sala",
  "Room Capacity": "Capacidad de la Sala",
  "Room Charges": "Cargos de la Sala",
  "Room Current Bookings": "Reservas Actuales de la Sala",
  "Instructor Availability": "Disponibilidad del Instructor",
  "Instructor Current Bookings": "Reservas Actuales del Instructor",
  "Instructor not available for the following dates and times": "Instructor no disponible para las siguientes fechas y horarios",
  "Room not available for the following dates and times": "Sala no disponible para las siguientes fechas y horarios",
  "Not within availability": "No dentro de la disponibilidad",
  "Add News": "Agregar Noticias",
  "Waiting for Approval": "Esperando aprobación",
  "Are you sure you want to complete this": "Estás seguro de que quieres completar esto",
  "Please complete all subtasks before marking the task as completed": "Por favor, completa todas las subtareas antes de marcar la tarea como completada",
  "Mark subtask as complete to move task to In Progress": "Marca la subtarea como completa para mover la tarea a En Progreso",
  "wants to join a Group": "quiere unirse a un grupo llamado",
  "wants to publish an updated Group": "quiere publicar una actualización de un grupo llamado",
  "has updated the Group": "se ha actualizado el grupo",
  "invited you to": "te ha invitado a",
  "wants to publish a Group": "quiere publicar un grupo llamado",
  "has denied the Group": "ha negado el grupo",
  "has been added to the Group": "se ha agregado el grupo",
  "has published the Group": "se ha publicado el grupo",
  "wants to publish a News": "quiere publicar un artículo llamado",
  "wants to publish an updated News": "quiere publicar una actualización de un artículo llamado",
  "has denied the News": "ha negado el artículo",
  "has published the News": "se ha publicado la noticia",
  "has updated the News": "se ha actualizado la noticia",
  "wants to publish an Event": "quiere publicar un evento llamado",
  "wants to publish an updated Event": "quiere publicar una actualización de un evento llamado",
  "has denied the Event": "ha negado el evento",
  "has published the Event": "se ha publicado el evento",
  "has updated the Event": "se ha actualizado el evento",
  "invited you to an Event": "ha sido invitado a un evento",
  "has updated Event for existing users": "se ha actualizado para usuarios existentes",
  "wants to publish a Course": "quiere publicar un curso llamado",
  "wants to publish an updated Course": "quiere publicar una actualización de un curso llamado",
  "wants to join a Course you have created": "quiere unirse a un curso que creaste",
  "has been added to a Course by the creator": "ha sido agregado a un curso por el creador",
  "invited you to a Course": "ha sido invitado a un curso",
  "wants to assign Instructor to a Course": "quiere asignar instructores para un curso",
  "wants to update assigned Instructor of a Course": "quiere actualizar los instructores asignados para un curso",
  "has published the Course": "se ha publicado el curso",
  "has updated the Course": "se ha actualizado el curso",
  "has denied the Course": "ha negado el curso",
  "invited you to a Task": "ha sido invitado a una tarea",
  "wants to publish a Task": "quiere publicar una tarea llamada",
  "wants to publish an updated Task": "quiere publicar una actualización de una tarea llamada",
  "has unapproved the Task": "tiene tareas no aprobadas",
  "has unapproved the Subtask": "tiene subtareas no aprobadas",
  "has denied the Task": "ha negado la tarea",
  "has published the Task": "se ha publicado la tarea",
  "has updated the Task": "se ha actualizado la tarea",
  "has completed the Task": "ha completado una tarea",
  "has sent you a message": "te ha enviado un mensaje",
  "wants to publish a Survey": "quiere publicar una encuesta llamada",
  "wants to publish an updated Survey": "quiere publicar una actualización de una encuesta llamada",
  "has invited you to participate in a Survey": "le ha invitado a participar en una Encuesta",
  "has published the Survey": "se ha publicado la encuesta",
  "has updated the Survey": "se ha actualizado la encuesta",
  "has denied the Survey": "ha negado la encuesta",
  "wants to publish a Room": "quiere publicar una sala",
  "wants to publish an updated Room": "quiere publicar una sala actualizada",
  "has published the Room": "se ha publicado la sala",
  "has updated the Room": "se ha actualizado la sala",
  "has denied the Room": "ha negado la sala",
  "wants to publish an Instructor": "quiere publicar un instructor",
  "wants to publish an updated Instructor": "quiere publicar un instructor actualizado",
  "has denied the Instructor": "ha negado el instructor",
  "has published the Instructor": "se ha publicado el instructor",
  "has updated the Instructor": "se ha actualizado el instructor",
  "wants to publish an FAQ": "quiere publicar un FAQ",
  "wants to publish an updated FAQ": "quiere publicar un FAQ actualizado",
  "has published the FAQ": "se ha publicado el FAQ",
  "wants to publish an updated FAQ to author": "quiere publicar un FAQ actualizado al autor",
  "has denied the FAQ to author": "ha negado el FAQ al autor",
  "wants to publish an FAQ category": "quiere publicar una categoría de FAQ",
  "Unknown notification type": "Tipo de notificación desconocido",
  "Occupancy": "Ocupación",
  "Free": "Libre",
  "Calendar": "Calendario",
  "Jan": "Ene",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Abr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dic",
  "mo": "Lu",
  "tu": "Ma",
  "we": "Mi",
  "th": "Ju",
  "fr": "Vi",
  "sa": "Sá",
  "su": "Do",
  "mo 1": "L",
  "tu 1": "M",
  "we 1": "M",
  "th 1": "J",
  "fr 1": "V",
  "sa 1": "S",
  "su 1": "D",
  "current": "Actual",
  "all": "Todo",
  "monday": "Lunes",
  "tuesday": "Martes",
  "wednesday": "Miércoles",
  "thursday": "Jueves",
  "friday": "Viernes",
  "saturday": "Sábado",
  "sunday": "Domingo",
  "january": "Enero",
  "february": "Febrero",
  "march": "Marzo",
  "april": "Abril",
  "may": "Mayo",
  "june": "Junio",
  "july": "Julio",
  "august": "Agosto",
  "september": "Septiembre",
  "october": "Octubre",
  "november": "Noviembre",
  "december": "Diciembre",
  "just now": "justo ahora",
  "a minute ago": "hace un minuto",
  "minutes ago": "hace minutos",
  "an hour ago": "hace una hora",
  "hours ago": "hace horas",
  "yesterday": "ayer",
  "a week ago": "hace una semana",
  "weeks ago": "hace semanas",
  "Click to download": "Haz clic para descargar",
  "Click to preview": "Haz clic para vista previa",
  "Survey Results": "Resultados de la Encuesta",
  "Survey Results Details": "Detalles de los Resultados de la Encuesta",
  "Survey Created By": "Encuesta Creada Por",
  "Survey Has been Closed": "La Encuesta ha sido Cerrada",
  "You've not voted": "No has votado",
  "My Vote": "Mi Voto",
  "To Vote": "Votar",
  "My Vote: You can select Multiple Options": "Mi Voto: Puedes seleccionar Múltiples Opciones",
  "My Vote: You can select only one option": "Mi Voto: Solo puedes seleccionar una opción",
  "Following people has voted For this option:": "Las siguientes personas han votado por esta opción:",
  "Total Number of Votes for this Option:": "Número total de votos para esta opción:",
  "other": "otro",
  "Members": "Miembros",
  "Search Filter": "Filtro de búsqueda",
  "Search": "Buscar",
  "Search Results": "Resultados de la búsqueda",
  "Last Active": "Última Actividad",
  "Status": "Estado",
  "Role": "Rol",
  "Online": "En línea",
  "Offline": "Desconectado",
  "List": "Lista",
  "Members List": "Lista de Miembros",
  "Created": "Creado",
  "Paid": "Pagado",
  "Unpaid": "No pagado",
  "Active": "Activo",
  "Inactive": "Inactivo",
  "Apply Filter": "Aplicar filtro",
  "Anonymous": "Anónimo",
  "Show hidden events": "Mostrar eventos ocultos",
  "Hide Event": "Ocultar Evento",
  "UnHide Event": "Mostrar Evento",
  "Banner Placement": "Colocación del banner",
  "Banner Display Tags": "Etiquetas de visualización del banner",
  "Create New Tag": "Crear nueva etiqueta",
  "Task Type": "Tipo de tarea",
  "Leave Event": "Salir del evento",
  "Join Event": "Unirse al evento",
  "Join This Event": "Unirse a este evento",
  "Join All Events in Series": "Unirse a todos los eventos de la serie",
  "Join Event on Specific Dates": "Unirse al evento en fechas específicas",
  "Accept event": "Aceptar evento",
  "Deny event": "Rechazar evento",
  "Publish event": "Publicar evento",
  "Event Members": "Miembros del Evento",
  "Event Tasks": "Tareas del Evento",
  "Event Details": "Detalles del Evento",
  "About group": "Acerca del grupo",
  "Show more": "Mostrar más",
  "Your team": "Tu equipo",
  "Responsible": "Responsable",
  "Collaborators": "Colaboradores",
  "Work Shifts": "Turnos de Trabajo",
  "Create Work Shift": "Crear Turno de Trabajo",
  "NO Of Shifts": "NO de Turnos",
  "No Shifts Data found": "No se encontraron datos de turnos",
  "Error while fetching Shifts Details": "Error al obtener los detalles de los turnos",
  "Shift": "Turno",
  "Form": "Formulario",
  "No new notifications": "No hay nuevas notificaciones",
  "No Data": "Sin Datos",
  "Add Work-shifts to an event": "Agregar turnos de trabajo a un evento",
  "Click to open details": "Haz clic para abrir los detalles",
  "permanently": "permanentemente",
  "Folder": "Carpeta",
  "Star Message": "Marcar mensaje",
  "Unstar Message": "Desmarcar mensaje",
  "Impressum": "Aviso Legal",
  "Terms and Conditions": "Términos y Condiciones",
  "Terms of Use": "Términos de Uso",
  "Privacy Policy": "Política de Privacidad",
  "You can find our applicable documents here": "Puede encontrar nuestros documentos aplicables aquí",
  "Club Administration": "Administración del Club",
  "Financial Accounting": "Contabilidad Financiera",
  "License & More": "Licencia y Más",
  "Documents": "Documentos",
  "Current Statuses": "Estados Actuales",
  "Corporate Philosophy": "Filosofía Corporativa",
  "Corporate": "Corporativo",
  "Archive": "Archivado",
  "All": "Todos",
  "Tables": "Tablas",
  "Images": "Imágenes",
  "Delete File": "Eliminar Archivo",
  "Download File": "Descargar Archivo",
  "Preview Image": "Vista previa de imagen",
  "Upload Document": "Subir Documento",
  "Move to My Documents": "Mover a Mis Documentos",
  "Move to Archived": "Mover a Archivado",
  "Move to Current Statuses": "Mover a Estados Actuales",
  "Move to Club Documents": "Mover a Documentos del Club",
  "Move to Corporate Documents": "Mover a Documentos Corporativos",
  "Move to Corporate Philosophy": "Mover a Filosofía Corporativa",
  "Ascending": "Ascendente",
  "Descending": "Descendente",
  "Order By": "Ordenar por",
  "Order": "Orden",
  "date": "Fecha",
  "name": "Nombre",
  "Are you sure you want to move": "¿Estás seguro de que deseas mover?",
  "Document moved successfully": "Documento movido exitosamente",
  "Only PDF files are allowed in Current Statuses": "Solo se permiten archivos PDF en Estados Actuales",
  "Upload Successful": "Subida Exitosa",
  "Profile": "Perfil",
  "Attachment": "Adjunto",
  "Download Attachment": "Descargar Adjunto",
  "Author": "Autor",
  "CRM Surveys": "Encuestas CRM",
  "CRM Survey": "Encuesta CRM",
  "Voting Results": "Resultados de la Votación",
  "Total Votes": "Votos Totales",
  "Votes": "Votos",
  "Close": "Cerrar",
  "Thank you for your vote": "Gracias por tu voto",
  "By": "Por",
  "CRM News": "Noticias CRM",
  "Read": "Leído",
  "Mark all notifications as read": "Marcar todas las notificaciones como leídas",
  "Close this notification": "Cerrar esta notificación",
  "Phone": "Teléfono",
  "Published by": "Publicado por",
  "Deleted User": "Usuario Eliminado",
  "Delete Chat": "Eliminar Chat",
  "Availability": "Disponibilidad",
  "Availability locked due to bookings.": "Disponibilidad bloqueada por reservas.",
  "Enter Name": "Introducir Nombre",
  "Enter Email": "Introducir Correo Electrónico",
  "Phone No": "Número de Teléfono",
  "Enter Phone No": "Introducir Número de Teléfono",
  "Enter Address": "Introducir Dirección",
  "No Of Persons": "Número de Personas",
  "Enter No Of Persons": "Introducir Número de Personas",
  "Price": "Precio",
  "First Name": "Nombre",
  "Enter First Name": "Introducir Nombre",
  "Last Name": "Apellido",
  "Enter Last Name": "Introducir Apellido",
  "Enter Qualification": "Introducir Calificación",
  "Repeat Course": "Repetir Curso",
  "Delete Selected": "Eliminar Seleccionado",
  "Deselect All": "Deseleccionar Todo",
  "Statistics": "Estadísticas",
  "Clicks": "Clics",
  "Banner Statistics": "Estadísticas de Banner",
  "Banner Desktop Clicks": "Clics de Banner de Escritorio",
  "Select Admin": "Seleccionar Administrador",
  "Group Chat": "Chat de Grupo",
  "Groupchat": "Chat de Grupo",
  "Personal Chat": "Chat Personal",
  "Created By": "Creado Por",
  "Invoice": "Factura",
  "Profile Image": "Imagen de Perfil",
  "Share Birthday": "Compartir cumpleaños",
  "Allow Advertisement": "Permitir Publicidad",
  "Date From": "Fecha Desde",
  "Date To": "Fecha Hasta",
  "m ago": "hace {{count}} minuto(s)",
  "h ago": "hace {{count}} hora(s)",
  "d ago": "hace {{count}} día(s)",
  "w ago": "hace {{count}} semana(s)",
  "mo ago": "hace {{count}} mes(es)",
  "Completed Subtasks": "Subtareas Completadas",
  "Total Subtasks": "Total de Subtareas",
  "Task Assigned to": "Tarea Asignada a",
  "To be done by": "Por hacer por",
  "This Task Only Completed by Admin, Organizer and Collaborators of this Task": "Esta tarea solo puede ser completada por el administrador, organizador y colaboradores de esta tarea",
  "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask": "No tienes permiso para completar esta subtarea, solo los participantes de esta tarea y subtareas, el organizador de esta tarea y el administrador pueden completar esta subtarea",
  "Desktop": "Escritorio",
  "Notification Section": "Sección de notificaciones",
  "Everywhere": "En todas partes",
  "Welcome to your club community!": "¡Bienvenido a tu comunidad de club!",
  "Stay networked with your club, exchange ideas and organize everything in one place.": "Mantente conectado con tu club, intercambia ideas y organiza todo en un solo lugar.",
  "Everything you need for your club - in one place.": "Todo lo que necesitas para tu club, en un solo lugar.",
  "Simply register, contact members, plan appointments and achieve more together.": "Solo regístrate, contacta miembros, planifica citas y logra más juntos.",
  "Stay connected - anytime, anywhere.": "Mantente conectado, en cualquier momento y en cualquier lugar.",
  "Access important information, share news and collaborate with your team.": "Accede a información importante, comparte noticias y colabora con tu equipo.",
  "Happy Birthday": "Feliz Cumpleaños",
  "Happy Anniversary": "Feliz Aniversario",
  "Instant and uncomplicated chatting with members or groups": "Chat instantáneo y sin complicaciones con miembros o grupos",
  "Your own mailbox based on the classic e-mail": "Tu propio buzón basado en el correo electrónico clásico",
  "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed": "Tipo o tamaño de archivo no válido. Solo se permiten imágenes PNG, JPEG y documentos permitidos de hasta 10MB",
  "Club Overview": "Resumen del Club",
  "Happenings": "Acontecimientos",
  "Occasions": "Ocasiones",
  "No:": "No:",
  "Password changed successfully. Please login again": "Contraseña cambiada con éxito. Por favor, inicia sesión de nuevo",
  "This is a private group. You need to request to join this group": "Este es un grupo privado. Necesitas solicitar unirte a este grupo",
  "Your request to join this group is pending": "Tu solicitud para unirte a este grupo está pendiente",
  "Your request to join this group has been rejected": "Tu solicitud para unirte a este grupo ha sido rechazada",
  "Confirm Delete": "Confirmar Eliminación",
  "No news has been created in the club yet": "Aún no se ha creado ninguna noticia en el club",
  "No news has been created in any Group yet": "Aún no se ha creado ninguna noticia en ningún grupo",
  "No group has been created in the club yet": "Aún no se ha creado ningún grupo en el club",
  "No events available": "No hay eventos disponibles",
  "Additional address": "Dirección adicional",
  "You have no notifications": "No tienes notificaciones",
  "Information about the course": "Información sobre el curso",
  "Further information about the course": "Más información sobre el curso",
  "Invite Participants": "Invitar Participantes",
  "Select all": "Seleccionar todo",
  "Unselect all": "Deseleccionar todo",
  "Done": "Hecho",
  "You already have a pending change request": "Ya tienes una solicitud de cambio pendiente",
  "Messages": "Mensajes",
  "Calendar view": "Vista de calendario",
  "Card view": "Vista de tarjetas",
  "Mark As Complete": "Marcar como Completado",
  "No Bookings": "Sin Reservas",
  "Schedule view": "Vista de Horario",
  "Hide Empty Slots": "Ocultar Espacios Vacíos",
  "Group Filter": "Filtro de Grupo",
  "No Conversation": "Sin Conversación",
  "Select Event Dates": "Seleccionar Fechas del Evento",
  "Select the dates you want to join for this event": "Selecciona las fechas a las que deseas unirte para este evento",
  "Join Selected Dates": "Unirse a las Fechas Seleccionadas",
  "Selected": "Seleccionado",
  "dates": "fechas",
  "new": "nuevo",
  "Please select at least one new date": "Por favor, selecciona al menos una nueva fecha",
  "No available dates for this event": "No hay fechas disponibles para este evento",
  "Accept This Event": "Aceptar este evento",
  "Accept All Events in Series": "Aceptar todos los eventos de la serie",
  "Accept Event on Specific Dates": "Aceptar evento en fechas específicas",
  "DIVIDER": "-------------------------------------------------------------DIVIDER---------------------------------------------------------------------",
  "formErrors": {
    "is required.": "es obligatorio.",
    "is invalid.": "no es válido.",
    "is required to be at least": "debe tener al menos",
    "cannot be longer than": "no puede ser más largo que",
    "can't be greater than": "no puede ser mayor que",
    "can't be less than": "no puede ser menor que",
    "must contain at least 1 in Capital Case!": "debe contener al menos 1 en Mayúscula!",
    "must contain at least 1 Letter in Small Case!": "debe contener al menos 1 letra en Minúscula!",
    "must contain at least 1 Special Character!": "debe contener al menos 1 Carácter Especial!",
    "do not match.": "no coinciden.",
    "must be unique.": "debe ser único.",
    "must be greater than 0.": "debe ser mayor que 0.",
    "must be greater.": "debe ser mayor.",
    "must be greater than or equal.": "debe ser mayor o igual.",
    "must be after the start date.": "debe ser después de la fecha de inicio.",
    "invalid pattern": "patrón inválido",
    "invalid pattern, 12345-1234 or 12345": "patrón inválido, 12345-1234 o 12345"
  },
  "loginForm": {
    "Login into your account": "Iniciar sesión en tu cuenta",
    "Username": "Nombre de usuario",
    "Password": "Contraseña",
    "Remember me": "Recuérdame",
    "I forgot my password": "Olvidé mi contraseña",
    "Don't have an account?": "¿No tienes una cuenta?",
    "Login": "Iniciar sesión",
    "Sign up for Verein.cloud": "Regístrate en verein.cloud®",
    "Password (6+ characters)": "Contraseña (6+ caracteres)"
  },
  "buttonComponent": {
    "Login": "Iniciar sesión",
    "Success": "Éxito",
    "Save": "Guardar",
    "Processing": "Procesando",
    "Error": "Error",
    "Cancel": "Cancelar",
    "done": "Hecho",
    "Join Event": "Unirse al evento",
    "Leave Event": "Salir del evento"
  },
  "header": {
    "open": "Abrir",
    "close": "Cerrar",
    "start typing": "Empieza a escribir..",
    "messages": "Mensajes"
  },
  "nav": {
    "event tasks": "Tareas de Evento",
    "event members": "Miembros del Evento",
    "create event form": "Formulario de Creación de Eventos",
    "dashboard": "Tablero",
    "news": "Noticias",
    "clubWall": "Muro del Club",
    "community": "Comunidad",
    "organizer": "Organizador",
    "courses": "Cursos",
    "tasks": "Tareas",
    "events": "Eventos",
    "messages": "Mensajes",
    "settings": "Configuración",
    "appointments": "Citas",
    "messages&groups": "Mensajes & Grupos",
    "task&appointments": "Tareas & Citas",
    "groups": "Grupos",
    "academic": "Académico",
    "app store": "App Store",
    "my profile": "Mi perfil",
    "profile": "Perfil",
    "club tools": "Herramientas del club",
    "marketing": "Marketing",
    "marketing tools": "Herramientas de Marketing",
    "banners": "Banners",
    "create banner": "Crear banner",
    "create event": "Crear evento",
    "emails": "Correos Electrónicos",
    "create email": "Crear correo electrónico",
    "tags": "Etiquetas",
    "survey": "Encuestas",
    "course management": "Gestión de cursos",
    "club FAQs": "Preguntas frecuentes del club",
    "group details": "Detalles del grupo",
    "chat": "Chat",
    "events & club dates": "Eventos y Fechas del Club",
    "club addons": "Complementos del Club",
    "more": "Más",
    "documents": "Documentos",
    "add": "Agregar",
    "faq": "Preguntas más frecuentes",
    "my content": "Mi Contenido"
  },
  "dashboard": {
    "news posts": "Publicaciones de noticias",
    "message chats": "Chats de mensajes",
    "tasks events": "Eventos de tareas",
    "tasks": "Tareas",
    "news from the club": "Noticias del club",
    "current club dates": "Fechas actuales del club",
    "participant": "Participante",
    "read more": "Leer más",
    "clock": "Reloj",
    "popular": "Popular",
    "latest": "Último",
    "Available Tasks": "Tareas disponibles",
    "message": "Mensaje",
    "chats": "Chats",
    "available": "Disponible",
    "posts": "Publicaciones"
  },
  "community": {
    "group overview": "Resumen del grupo",
    "dashboard": "Tablero",
    "community": "Comunidad",
    "messages": "Mensajes",
    "groups": "Grupos",
    "members": "Miembros",
    "open chat": "Abrir chat",
    "leave": "Salir",
    "edit": "Editar",
    "delete": "Eliminar",
    "add": "Agregar",
    "create": "Crear",
    "show all groups": "Mostrar todos los grupos",
    "groups you manage": "Grupos que administras",
    "groups you are a member of": "Grupos de los que eres miembro"
  },
  "groups": {
    "groups": "Grupos",
    "group": "Grupo",
    "group details": "Detalles del grupo",
    "members": "Miembros",
    "news": "Noticias",
    "tasks": "Tareas",
    "events": "Eventos",
    "about": "Acerca de",
    "About this group": "Acerca de este grupo",
    "set": "Set",
    "your team": "Tu equipo",
    "new": "Nuevo",
    "group admin": "Administrador de grupo",
    "age": "Edad",
    "no group": "Sin grupo",
    "no event": "Sin evento",
    "no task": "Sin tarea",
    "no news": "Sin noticias",
    "no member": "Sin miembro",
    "join success message": "Te has unido al grupo correctamente.",
    "waiting admin approval": "Esperando la aprobación del administrador",
    "leave success message": "Has abandonado el grupo correctamente.",
    "delete success message": "Grupo eliminado correctamente."
  },
  "banners": {
    "link": "Enlace",
    "content": "Contenido",
    "description": "Descripción",
    "banner status": "Estado",
    "update courses": "Actualizar cursos",
    "banner invoice": "Factura",
    "banner category": "Categoría",
    "add description": "Agregar descripción",
    "create banner": "Crear banner",
    "thumbnail": "Miniatura",
    "add image": "Agregar imagen",
    "title": "Título",
    "sponsor": "Patrocinador",
    "open space": "Espacio abierto",
    "app sponsor": "Patrocinador de la aplicación",
    "group details": "Detalles del grupo",
    "all groups": "Todos los grupos",
    "all news": "Todas las noticias",
    "not paid": "No pagado",
    "save": "Guardar",
    "banner categories": "Categorías de banner",
    "banner images": "Imágenes de banner",
    "banner link": "Enlace del banner",
    "cancel": "Cancelar",
    "banner title": "Título del banner",
    "edit banner": "Editar banner",
    "banner display": "Mostrar",
    "news details": "Detalles de las noticias",
    "banner placement": "Colocación",
    "banner display tag": "Mostrar etiqueta de banner",
    "banner redirect link": "Enlace de redireccionamiento"
  },
  "dates&filters": {
    "date": "Fecha",
    "days": "Días",
    "day": "Día",
    "hour": "Hora",
    "hours": "Horas",
    "time": "Hora",
    "year": "Año",
    "years": "Años",
    "month": "Mes",
    "months": "Meses",
    "week": "Semana",
    "weeks": "Semanas",
    "opinion": "Opinión",
    "event type": "Tipo de evento",
    "sort and filter": "Ordenar y filtrar",
    "clear filters": "Borrar filtros",
    "clear": "Borrar",
    "expired": "Expirado"
  },
  "messages": {
    "new group": "Nuevo grupo",
    "new chat": "Nuevo chat",
    "chat": "Chat",
    "personal": "Personal",
    "club": "Club",
    "group": "Grupo",
    "clubs": "Clubs",
    "members": "Miembro",
    "write a message": "Escribir un mensaje",
    "media links and docs": "Medios, enlaces y documentos",
    "group in common": "Grupo en común",
    "close": "Cerrar",
    "group name": "Nombre del grupo",
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "report": "Reportar"
  },
  "tags": {
    "tag": "Etiqueta",
    "tags": "Etiquetas",
    "tag name": "Nombre de la etiqueta",
    "create tag": "Crear etiqueta",
    "instructor tag name": "Nombre de la etiqueta del instructor",
    "room tag name": "Nombre de la etiqueta de la sala",
    "instructor": "Instructor",
    "room": "habitación",
    "new tag": "Nueva etiqueta"
  },
  "users": {
    "my profile": "Mi Perfil",
    "user profile": "Perfil de Usuario",
    "user": "Usuario",
    "general information": "Información General",
    "my payment data": "Mis Datos de Pago",
    "association master data": "Datos Maestros de la Asociación",
    "me at the club": "Yo en el club",
    "I in the company": "Yo en la empresa",
    "my address information": "Mi Información de Dirección",
    "communication data": "Datos de Comunicación",
    "street number": "Número de Calle",
    "more info": "Más Información",
    "city": "Ciudad",
    "zip code": "Código Postal",
    "e-mail address": "Dirección de Correo Electrónico",
    "phone number": "Número de Teléfono",
    "date of birth": "Fecha de Nacimiento",
    "address supplement": "Complemento de Dirección",
    "save profile": "Guardar Perfil",
    "password information": "Información de Contraseña",
    "old password": "Contraseña Antigua",
    "minimum 6 characters": "Mínimo 6 caracteres",
    "change": "Cambiar",
    "bank holder name": "Nombre del Titular de la Cuenta",
    "iban": "IBAN",
    "bic": "BIC",
    "social links": "Enlaces Sociales",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "instagram": "Instagram",
    "homepage": "Página de Inicio",
    "country": "País",
    "bank name": "Nombre del Banco",
    "member ship start date": "Fecha de Inicio de Membresía",
    "My role in verein.cloud®": "Mi rol en verein.cloud®"
  },
  "club_tools": {
    "create question": "Crear pregunta",
    "faq categories": "Categorías de FAQ",
    "start searching": "Comenzar la búsqueda",
    "membership": "Membresía",
    "maintenance and care": "Mantenimiento y cuidado",
    "create faq": "Crear Preguntas Frecuentes",
    "update faq": "Actualizar Preguntas Frecuentes",
    "create title": "Crear título",
    "add description here": "Agregar descripción aquí"
  },
  "courses": {
    "instructors": "Instructores",
    "rooms": "Aulas",
    "all instructors": "Todos los Instructores",
    "all rooms": "Todas las Aulas",
    "today": "Hoy",
    "upcoming": "Próximos",
    "join": "Unirse",
    "joined": "Unido",
    "rejected": "Rechazado",
    "persons": "Personas",
    "search by room name": "Buscar por nombre de habitación",
    "join course": "Unirse al curso",
    "sorting": "Ordenación",
    "participants": "Participantes",
    "about course": "Acerca del curso",
    "course details": "Detalles del curso",
    "helpText": "<p><strong>Managing Courses:</strong> Create courses by selecting available instructors and rooms that fit your schedule. Set visibility to 'Club Level' for everyone or 'Private' for specific groups/individuals, and assign tasks to stay organized.</p><p><strong>Discovering & Joining:</strong> Browse available courses in Card or Calendar views for your preferred dates and join with a single click.</p>"
  },
  "appointmentAndClub": {
    "start time": "Hora de inicio",
    "end time": "Hora de finalización",
    "visibility": "Visibilidad",
    "event name": "Nombre del evento",
    "event location": "Ubicación del evento",
    "room number (optional)": "Número de habitación (opcional)",
    "event price": "Precio del evento",
    "additional features": "Características adicionales",
    "show guests": "Mostrar invitados",
    "chargeable": "Cobrable",
    "create event": "Crear evento",
    "edit event": "Editar evento",
    "canceled": "Cancelado",
    "pending": "Pendiente",
    "confirmed": "Confirmado",
    "location": "Ubicación",
    "responsible": "Responsable",
    "join event": "Unirse al evento",
    "current": "Actual",
    "tile view": "Vista de mosaico",
    "list view": "Vista de lista",
    "board": "Tablero",
    "view": "Ver",
    "my contributions": "Mis contribuciones",
    "Birthdays and anniversaries in the club": "Cumpleaños y aniversarios en el club",
    "Current events in the club": "Eventos actuales en el club",
    "Current events in the company": "Eventos actuales en la empresa"
  },
  "my content": {
    "title image": "Imagen del título",
    "type": "Tipo",
    "actions": "Acciones",
    "faqs": "Preguntas frecuentes"
  },
  "userprofile": {
    "personal information": "Información personal",
    "create profile": "Crear perfil",
    "edit my profile": "Editar mi perfil",
    "digital membership card": "Tarjeta de membresía digital",
    "payment information": "Información de pago",
    "digital card": "Tarjeta digital",
    "card holder name": "Nombre del titular de la tarjeta",
    "card number": "Número de tarjeta",
    "card type": "Tipo de tarjeta",
    "expiration date": "Fecha de vencimiento",
    "membership information": "Información de membresía",
    "membership type": "Tipo de membresía",
    "membership number": "Número de membresía",
    "In the team since": "En el equipo desde",
    "approval / activation": "Aprobación / Activación",
    "fair-share function": "Función de participación justa"
  },
  "RRULE": {
    "approximate": "aproximado",
    "and": "y",
    "at": "a las",
    "day": "día",
    "days": "días",
    "every": "Cada",
    "for": "durante",
    "hour": "hora",
    "hours": "horas",
    "in": "en",
    "last": "último(s)",
    "minutes": "minutos",
    "month": "mes",
    "months": "meses",
    "nd": "nd",
    "on the": "el",
    "on": "en",
    "or": "o",
    "rd": "rd",
    "st": "st",
    "th": "th",
    "the": "el",
    "time": "vez",
    "times": "veces",
    "until": "hasta",
    "week": "semana",
    "weekday": "día de la semana",
    "weekdays": "días de la semana",
    "weeks": "semanas",
    "year": "año",
    "years": "años",
    "monthly": "mensual",
    "yearly": "anualmente",
    "weekly": "semanalmente",
    "daily": "diariamente",
    "hourly": "cada hora",
    "minutely": "cada minuto",
    "secondly": "cada segundo",
    "starting from": "a partir de",
    "MO": "lunes",
    "TU": "martes",
    "WE": "miércoles",
    "TH": "jueves",
    "FR": "viernes",
    "SA": "sábado",
    "SU": "domingo",
    "RRule error: Unable to fully convert this rrule to text": "Error en RRule: No se pudo convertir completamente esta RRule a texto"
  },
  "Add New": "Añadir nuevo",
  "Create Group News": "Crear noticia de grupo",
  "Create Group Task": "Crear tarea de grupo",
  "Create Group Event": "Crear evento de grupo"
}
